import { Component, OnInit, forwardRef } from '@angular/core';
import { PortfolioService } from '../../../api/portfolio/portfolio.service';
import { Router } from '@angular/router';

import 'rxjs/add/operator/catch';
import Sortable from 'sortablejs'

declare var $: any;
declare var jQuery: any;
import { ApiConstant } from '../../../api/api.constant'
import { Title } from '@angular/platform-browser';

var builder = require('xmlbuilder');


@Component({
    selector: 'application-page',
    templateUrl: './portfolio.html',
    styleUrls: ['./portfolio.css']
})

export class Portfolio implements OnInit {


    viewcodexmldescription : string;

    portfolio = [];
    i: number;
    j: number;
    id: string;
    pid: string;
    message: string;
    TableData = [];
    feature1title: string;
    feature1desc: string;
    feature2title: string;
    feature2desc: string;
    feature3title: string;
    feature3desc: string;
    feature4title: string;
    feature4desc: string;
    feature5title: string;
    feature5desc: string;
    feature6title: string;
    feature6desc: string;
    name: string;
    sku: string;
    description: string;
    keyword: string;
    metadescription: string;
    tag: string;
    technology: string;
    Android: string;
    youtubelink: string;
    facebooklink: string;
    ios: string;
    huawei: string;
    store1: string;
    logo: string;
    banner: string;
    url: string;
    shortdescription: string;
    showslidersize: string;
    index: number = 0;
    sliderstring: string;
    logoshow: boolean = false;
    showbanner: boolean = false;
    showfeatureimage: boolean = false;
    loading: boolean = false;
    sliderimage: string;
    headersliderimage: string;
    SEOdescription: string;
    SEOimage: string;
    featureimage: string;
    isactive: boolean = false
    image_url: string;
    type: string;
    theme: string;
    urls = new Array<string>();
    sliderimage_myFiles: Array<File> = [];
    SEOimage_myFiles: File
    featureimage_myFiles: File
    logo_myFiles: File
    banner_myFiles: File
    singlesliderimage_myFiles: File
    sliderimagesize: string = "portrait";
    sliderimagesize1: string = "portrait";
    header_slider_image_myFiles: File;
    sliderimagearray = [];
    imageid: string;
    public show: boolean = false;
    public showinputlogo: boolean = false;
    public showinputbanner: boolean = false;
    public showinputheadersliderimage: boolean = false;
    public showinputseoimage: boolean = false;
    public showinputfeatureimage: boolean = false;

    public showoriginallogo: boolean = true;
    public showoriginalbanner: boolean = true;

    public showoriginalheadersliderimage: boolean = true;
    public showoriginalfeatureimage: boolean = true;
    public showoriginalseoimage: boolean = true;




    isDataLoaded : boolean = false;
    isXmlGenerate : boolean = false;

    selectedColor = '#a7e2b5';
    selectedType = '';
    colors = [];
    types = [
        {
            value: 'Game'
        },
        {
            value: 'Apps'
        },
        {
            value: 'Web'
        }
    ];
    suggesttag = [];
    selectedtag = [];
    selectedtechnology = [];

    constructor(private PortfolioService: PortfolioService,
        private router: Router, private apiconstant: ApiConstant, private titleService: Title) {
    }

    ngOnInit() {

        this.titleService.setTitle("Portfolio | Phoenix Games");
        $(function () {
            $('.select4').select2();
            $('.select4-tags').select2({
                tags: true,
                tokenSeparators: [',', ' ']
            });
            $('.selectpicker').selectpicker();


            $('.select3').select2();
            $('.select3-tags').select2({
                tags: true,
                tokenSeparators: [',', ' ']
            });
            $('.selectpicker').selectpicker();
        });

        if (localStorage.getItem('token') && (localStorage.getItem('role') == 'SUPERADMIN' || localStorage.getItem('role') == 'ADMIN')) {
            $(function () {
                $('.summernote').summernote({
                    height: 350
                });
            });
            $(function () {
                $('.summernote2').summernote({
                    height: 350
                });
            });
            this.image_url = this.apiconstant.ServerUrl + "uploads/portfolio/"
            this.isDataLoaded = false;
            this.PortfolioService.allPortfolio()
                .then(data => {
                   
                    if(data.status)
                    {
                        for (let index = 0; index < data.data.length; index++) {
                            const element = data.data[index];
                            var _idd = element.sequenceindex;
                            if(_idd == undefined || _idd == null || _idd == "")
                            {
                                _idd = 0;
                            }
                            var JDDD = {
                                sequenceindex : _idd,
                                id : element.id,
                                name : element.name,
                                android : element.android,
                                ios : element.ios,
                                huawei : element.huawei,
                                store1 : element.store1,
                                counter : element.counter,
                                isactive : element.isactive,
                                pic : this.image_url +element.logo,
                                tag : element.tag,
                                technology : element.technology,
    
                                url : element.url,
                                shortdescription : element.shortdescription,
                                sku : element.sku,
                                description : element.description,
                                logo : element.logo,
                                banner : element.banner,
                                featureimage : element.featureimage,
                                metakeyword : element.metakeyword,
                                metadescription : element.metadescription,
                                youtubelink : element.youtubelink,
                                facebooklink : element.facebooklink,
                                type : element.type,
                                sliderimage : element.sliderimage,
                                imagetype : element.imagetype,
                                
                                portfoliofeature : {
                                    feature1title : element.portfoliofeature.feature1title,
                                    feature1desc : element.portfoliofeature.feature1desc,
    
                                    feature2title : element.portfoliofeature.feature2title,
                                    feature2desc : element.portfoliofeature.feature2desc,
    
                                    feature3title : element.portfoliofeature.feature3title,
                                    feature3desc : element.portfoliofeature.feature3desc,
    
                                    feature4title : element.portfoliofeature.feature4title,
                                    feature4desc : element.portfoliofeature.feature4desc,
    
                                    feature5title : element.portfoliofeature.feature5title,
                                    feature5desc : element.portfoliofeature.feature5desc,
    
                                    feature6title : element.portfoliofeature.feature6title,
                                    feature6desc : element.portfoliofeature.feature6desc,
                                }
                            }
    
                            this.portfolio.push(JDDD);
                        }
                        this.isDataLoaded = true;
                        this.suggesttag = data.tags;
                    }
                });
            // var el = document.getElementById('items');
            // var sortable = new Sortable(el, {
            //     animation: 150,
            //     ghostClass: 'blue-background-class'
            // });

            $(function () {
                var drEvent = $('.dropify').dropify();

                drEvent.on('dropify.afterClear', function (event, element) {

                });
            });
        } else {
            this.router.navigate(['/']);
        }
    }

    radioChangeHandler(event: any) { 
        this.sliderimagesize = event.target.value;
        $(function () {
            var drEvent = $('.dropify').dropify();

            drEvent.on('dropify.afterClear', function (event, element) {

            });
        });
    }

    onChange(value) {
        this.selectedColor = value;
    }

    getValueType(value) {

        this.selectedType = value;
        if (this.selectedType == 'Game') {
            this.feature1title = "Intuitive User Interface",
                this.feature1desc = "GAMENAME contains very intuitive, clean and easily understandable user interface",
                this.feature2title = "Robust User Experience",
                this.feature2desc = "GAMENAME's fast and responsiveness provides best and robust user experience to users",
                this.feature3title = "Unique Gameplay",
                this.feature3desc = " GAMENAME have very enjoyable gameplay which is perfect for relaxing and time passing",
                this.feature4title = "Revolutionary Mechanism",
                this.feature4desc = "GAMENAME is based on completely new mechanism which is revolutionary in gaming industry",
                this.feature5title = "Best Strategy",
                this.feature5desc = "GAMENAME provides real time simulation which makes your brain more strategic",
                this.feature6title = "Realistic Visulizations",
                this.feature6desc = "GAMENAME's next generation visualizations binds users and entertains them deeply"
        }
        if (this.selectedType == 'Apps') {
            this.feature1title = "Intuitive User Interface",
            this.feature1desc = "APPNAME contains very intuitive, clean and easily understandable user interface",
            this.feature2title = "Robust User Experience",
            this.feature2desc = "APPNAME's fast and responsiveness provides best and robust user experience to users",
            this.feature3title = "Easy Navigations",
            this.feature3desc = " APPNAME contains very easy navigation to take most out from it very effectively",
            this.feature4title = "Rich In Features",
            this.feature4desc = "APPNAME includes a lot of features which helps you to make things easier and quick",
            this.feature5title = "Must Have Application",
            this.feature5desc = "APPNAME is so good that it's user recommends everyone to use it on daily basis",
            this.feature6title = "Best Companion",
            this.feature6desc = "APPNAME helps you to do things smartly thus it's best companion for your daily life"
        }
    }

    cancelAction() {
        this.name = "";
        this.sku = "";
        this.feature1title = "";
        this.feature1desc = "";
        this.feature2title = "";
        this.feature2desc = "";
        this.feature3title = "";
        this.feature3desc = "";
        this.feature4title = "";
        this.feature4desc = "";
        this.feature5title = "";
        this.feature5desc = "";
        this.feature6title = "";
        this.feature6desc = "";
        this.description = "";
        this.keyword = "";
        this.metadescription = "";
        this.tag = "";
        this.technology = "";
        this.Android = "";
        this.youtubelink = "";
        this.facebooklink = "";
        this.ios = "";
        this.huawei = "";
        this.store1 = "";
        this.type = "";
        this.theme = "";
        this.logo = "";
        this.banner = "";
        this.sliderimage = "";
        this.headersliderimage = "";
        this.SEOdescription = "";
        this.SEOimage = "";
        this.featureimage = "";
        this.isactive = false;
        this.selectedColor = "#a7e2b5";
        this.selectedType = "";
        this.urls = [];
        this.sliderimage_myFiles = [];
        this.SEOimage_myFiles = null;
        this.featureimage_myFiles = null;
        this.logo_myFiles = null;
        this.banner_myFiles = null;
        this.header_slider_image_myFiles = null;
        $('div.note-editable').html("")
        this.selectedtag = [];
        this.selectedtechnology = [];
        this.url = "";
        this.singlesliderimage_myFiles = null;
        this.sliderstring = "";
        this.logoshow = false;
        this.showbanner = false;
        this.showfeatureimage = false;
        this.shortdescription = "";
        this.loading = false;

        this.sliderimagearray = [];
        $("#cleardata").val("");

        $(".radiodisabled").attr('disabled', false);
        $(".opacitydown").css('opacity', '1');
        this.sliderimagesize = "portrait";
        this.sliderimagesize1 = "portrait";
        $(function () {
            var drEvent = $('.dropify').dropify();

            drEvent.on('dropify.afterClear', function (event, element) {

            });
        });

        $(".select2-selection__choice").remove();
        $(".select2-selection__choice").remove();
        $('#mySelect2').val(null).trigger('change');
        $('#mySelect3').val(null).trigger('change');
        $('#mySelect4').val(null).trigger('change');
        $('#mySelect5').val(null).trigger('change');
    }

    removesliderimages(i2) {


        var position = i2;
        var appData = {
            position: position,
        };
        this.PortfolioService.dSliderimage(appData, this.id).then(data => {

            if (data.status) {
                this.urls.splice(i2, 1);

                this.sliderimage_myFiles.splice(i2, 1)
            } else {
                this.urls.splice(i2, 1);
                this.sliderimage_myFiles.splice(i2, 1)
            }
        });
    }

    removelogoimages() {
        this.showinputlogo = true;
        this.showoriginallogo = false;
        this.logo = null;

        $(function () {
            var drEvent = $('.dropify').dropify();
            drEvent.on('dropify.afterClear', function (event, element) {
            });
        });
    }

    removebannerimages() {
        this.showinputbanner = true;
        this.showoriginalbanner = false;
        this.banner = null;

        $(function () {
            var drEvent = $('.dropify').dropify();
            drEvent.on('dropify.afterClear', function (event, element) {
            });
        });
    }

    removeheadersliderimages() {
        this.showinputheadersliderimage = true;
        this.showoriginalheadersliderimage = false;
        this.headersliderimage = null;
        $(function () {
            var drEvent = $('.dropify').dropify();
            drEvent.on('dropify.afterClear', function (event, element) {
            });
        });
    }

    removeSEOimages() {
        this.showinputseoimage = true;
        this.showoriginalseoimage = false;
        this.SEOimage = null;
        $(function () {

            var drEvent = $('.dropify').dropify();

            drEvent.on('dropify.afterClear', function (event, element) {

            });
        });
    }

    removepurchaseimages() {
        this.showinputfeatureimage = true;
        this.showoriginalfeatureimage = false;
        this.featureimage = null;

        $(function () {

            var drEvent = $('.dropify').dropify();

            drEvent.on('dropify.afterClear', function (event, element) {

            });
        });
    }

    openfileDialog() {
        $("#fileLoader").click();
    }

    detectFilesSliderimage(event) {
        this.sliderimage_myFiles = [];

        $(".radiodisabled").attr('disabled', true);
        $(".opacitydown").css('opacity', '.5');

        let files = event.target.files;

        if (files.length > 0) {
            this.show = true;
        } else {
            this.show = false;
        }

        for (let file of files) {
            let reader = new FileReader();

            reader.onload = (e: any) => {
                var img = new Image();
                img.src = e.target.result;

                img.onload = () => {
                    var height = img.height;
                    var width = img.width;

                    if (this.sliderimagesize == "landscape") {
                        if (height == 1242 || width == 2208) {
                            this.sliderimage_myFiles.push(file);
                            return true;
                        }
                        else {

                            var message = file.name + "  image size is not valid";
                            alert(message);
                            return;
                        }
                    }
                    else if (this.sliderimagesize == "portrait") {
                        if (height == 2208 || width == 1242) {
                            this.sliderimage_myFiles.push(file);
                            return true;
                        }
                        else {
                            var message = file.name + "   image size is not valid";
                            alert(message);
                            return
                        }

                    }

                };
            };
            reader.readAsDataURL(file);
        }
    }

    updateList(i: number, property: string, event: any) 
    {
        const editField = event.target.textContent;
        this.portfolio[i][property] = editField.toString().trim();
    }


    gettingsequence() {
        var TableData = new Array();
        $('#row-table tr').each(function (row, tr) {
            TableData[row] = {
                "id": $(tr).find('td:eq(0)').text(),
                "index": $(tr).find('td:eq(2)').text(),
            }
        });
        TableData.shift();
        this.TableData = TableData;

        var tbdata = {
            tabledata: this.TableData
        };
        this.PortfolioService.uPortfolioindex(tbdata).then(data => {
            if (data.status) {
                $.notify({
                    message: "Sequence Successfully Changed"
                }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 2000
                    });

                    this.isDataLoaded = false;
                this.PortfolioService.allPortfolio()
                    .then(data => {
                        for (let index = 0; index < data.data.length; index++) {
                            const element = data.data[index];
                            var _idd = element.sequenceindex;
                            if(_idd == undefined || _idd == null || _idd == "")
                            {
                                _idd = 0;
                            }
                            var JDDD = {
                                sequenceindex : _idd,
                                id : element.id,
                                name : element.name,
                                android : element.android,
                                ios : element.ios,
                                huawei : element.huawei,
                                store1 : element.store1,
                                counter : element.counter,
                                isactive : element.isactive,
                                pic : this.image_url +element.logo,
                                tag : element.tag,
                                technology : element.technology,
    
                                url : element.url,
                                shortdescription : element.shortdescription,
                                sku : element.sku,
                                description : element.description,
                                logo : element.logo,
                                banner : element.banner,
                                featureimage : element.featureimage,
                                metakeyword : element.metakeyword,
                                metadescription : element.metadescription,
                                youtubelink : element.youtubelink,
                                facebooklink : element.facebooklink,
                                type : element.type,
                                sliderimage : element.sliderimage,
                                imagetype : element.imagetype,
                                
                                portfoliofeature : {
                                    feature1title : element.portfoliofeature.feature1title,
                                    feature1desc : element.portfoliofeature.feature1desc,
    
                                    feature2title : element.portfoliofeature.feature2title,
                                    feature2desc : element.portfoliofeature.feature2desc,
    
                                    feature3title : element.portfoliofeature.feature3title,
                                    feature3desc : element.portfoliofeature.feature3desc,
    
                                    feature4title : element.portfoliofeature.feature4title,
                                    feature4desc : element.portfoliofeature.feature4desc,
    
                                    feature5title : element.portfoliofeature.feature5title,
                                    feature5desc : element.portfoliofeature.feature5desc,
    
                                    feature6title : element.portfoliofeature.feature6title,
                                    feature6desc : element.portfoliofeature.feature6desc,
                                }
                            }
                            this.portfolio.push(JDDD);
                        }
                        this.isDataLoaded = true;
                        this.suggesttag = data.tags;
                    });
            } else {
                $.notify({
                    message: "Something Went Wrong"
                }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 2000
                    });

            }
        });
    }


    detectFilesslider(event) {
        $(".radiodisabled").attr('disabled', true);
        $(".opacitydown").css('opacity', '.8');

        var file = <File>event.target.files[0];
        let fr = new FileReader();
        fr.onload = (e: any) => {
            var img = new Image;
            img.src = e.target.result;
            img.onload = () => {
                var width = img.naturalWidth;
                var height = img.naturalHeight;

                if (width == 1242 && height == 2208) {
                    this.singlesliderimage_myFiles = <File>event.target.files[0];
                }
                else {
                    this.singlesliderimage_myFiles = null;
                }
            };
        };
        fr.readAsDataURL(file)



    }

    generatexmlCodeAll()
    {
        if(this.portfolio.length > 0)
        {
            this.isXmlGenerate = true;
            this.viewcodexmldescription = "";
            var data = {
                
            }
            this.PortfolioService.allimage(data).then(data1 => {
                var _data = "";
                for (let index = 0; index < this.portfolio.length; index++) 
                {
                    const elementPortfolio = this.portfolio[index];
                    

                    var appgameName = elementPortfolio.name;

                    var subtitle1 = elementPortfolio.url.replace(/\s/g, "-")
                   
                    var appgameUrl = this.apiconstant.MainUrl+"portfoliodetail/"+subtitle1+"/"+btoa(elementPortfolio.id);
                    var logoImagePath = elementPortfolio.logo;
                    var bannerImagePath = elementPortfolio.banner;
                    var featureimageImagePath = elementPortfolio.featureimage;
                
                
                    var createdDate = this.dateFormate() + this.timeForamte();
                
                    var root = builder.create('url');  
                
                    root.ele('loc',appgameUrl)
                    root.ele('lastmod',createdDate)
                    var imgLogo =  root.ele('image:image')
                    imgLogo.ele('image:loc','https://api.phoenixgames.in/uploads/portfolio/'+logoImagePath)
                    imgLogo.ele('image:title','<![CDATA['+appgameName+' Logo Phoenix Games]]>')
                    imgLogo.ele('image:caption','<![CDATA['+appgameName+' Logo Phoenix Games]]>')
                
                    var imgBanner =  root.ele('image:image')
                    imgBanner.ele('image:loc','https://api.phoenixgames.in/uploads/portfolio/'+bannerImagePath)
                    imgBanner.ele('image:title','<![CDATA['+appgameName+' Banner Phoenix Games]]>')
                    imgBanner.ele('image:caption','<![CDATA['+appgameName+' Banner Phoenix Games]]>')
                
                    var imgFeatureimage =  root.ele('image:image')
                    imgFeatureimage.ele('image:loc','https://api.phoenixgames.in/uploads/portfolio/'+featureimageImagePath)
                    imgFeatureimage.ele('image:title','<![CDATA['+appgameName+' Feature Phoenix Games]]>')
                    imgFeatureimage.ele('image:caption','<![CDATA['+appgameName+' Feature Phoenix Games]]>')
                

                    var itemss = data1.data.filter(function (element) {
                        return element.id == elementPortfolio.id;
                    });
                   
                        for (let index = 0; index < itemss.length; index++) 
                        {   
                            var screenshotImagePath = itemss[index]["name"];
                           
                            var imgScreenshot =  root.ele('image:image')
                            imgScreenshot.ele('image:loc','https://api.phoenixgames.in/uploads/portfolio/'+screenshotImagePath)
                            imgScreenshot.ele('image:title','<![CDATA['+appgameName+' Screenshot '+(index +1)+' Phoenix Games]]>')
                            imgScreenshot.ele('image:caption','<![CDATA['+appgameName+' Screenshot '+(index +1)+' Phoenix Games]]>')
                        }
                    
            
                    var xml = root.end({ pretty: true});
                
                    var finalstring = xml.toString();
                    
                   
                    _data += "\n"+ finalstring;
                }

                let re = /\&lt;/gi;
                let re1 = /\&gt;/gi;
                let re2 = /\=/gi;
                var finalstring1 = _data.replace(re,'<')
                var finalstring2 = finalstring1.replace(re1,'>')
                var finalstring3 = finalstring2.replace(re2,'%3D')


                var lines = finalstring3.split('\n');

                var finalstring4 = "";

                for(var i = 0;i < lines.length;i++){
                    //code here using lines[i] which will give you each line
                    if(!lines[i].includes("<?xml"))
                    {
                        finalstring4 += "\n"+lines[i];
                    }
                }
                this.viewcodexmldescription = finalstring4;
                this.isXmlGenerate = false;
                $(function () {
                    $('#viewcodePortfolio').modal('toggle');
                });
            })
           
           
        }
      
    }

    detectFilesslider1(event) {

        $(".radiodisabled").attr('disabled', true);
        $(".opacitydown").css('opacity', '.8');

        var file = <File>event.target.files[0];
        let fr = new FileReader();
        fr.onload = (e: any) => {
            var img = new Image;
            img.src = e.target.result;
            img.onload = () => {
                var width = img.naturalWidth;
                var height = img.naturalHeight;

                if (width == 2208 && height == 1242) {
                    this.singlesliderimage_myFiles = <File>event.target.files[0];
                }
                else {
                    this.singlesliderimage_myFiles = null;
                }
            };
        };
        fr.readAsDataURL(file)
    }

    detectFileslogo(event) {

        var column1RelArray = [];
        var column2RelArray = [];

        $('.select4-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column1RelArray.push($(this).attr('title'));
        });
        $('.select3-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column2RelArray.push($(this).attr('title'));
        });
        column1RelArray = column1RelArray.filter(function (element) {
            return element !== undefined;
        });
        column2RelArray = column2RelArray.filter(function (element) {
            return element !== undefined;
        });
        for (var i = 0; i < column1RelArray.length; i++) {
            column1RelArray[i] = column1RelArray[i].trim();
        }
        for (var i = 0; i < column2RelArray.length; i++) {
            column2RelArray[i] = column2RelArray[i].trim();
        }
        if (this.name == undefined || this.name == "") {
            alert("Please Enter Name.")
            return;
        }
        else if (this.sku == undefined || this.sku == "") {
            alert("Please Enter SKU.")
            return;
        }
        else if (column1RelArray.length == 0 || column1RelArray == null) {
            alert("Please Enter Atleast One Tag")
            return;
        } else if (column2RelArray.length == 0 || column2RelArray == null) {
            alert("Please Enter Atleast One Technology")
            return;
        }
        else if (this.url == undefined || this.url == null) {
            alert("Please Enter Atleast One Url")
            return;
        }

        var file = <File>event.target.files[0];
        let fr = new FileReader();
        fr.onload = (e: any) => {
            var img = new Image;
            img.src = e.target.result;
            img.onload = () => {
                var width = img.naturalWidth;
                var height = img.naturalHeight;

                if (width == 512 && height == 512) {

                    this.logo_myFiles = <File>event.target.files[0];
                    this.submitlogoimage();
                }
                else {
                    this.logo_myFiles = null;
                }
            };
        };
        fr.readAsDataURL(file)

    }


    detectFilesbanner(event) {
        var column1RelArray = [];
        var column2RelArray = [];

        $('.select4-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column1RelArray.push($(this).attr('title'));
        });
        $('.select3-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column2RelArray.push($(this).attr('title'));
        });
        column1RelArray = column1RelArray.filter(function (element) {
            return element !== undefined;
        });
        column2RelArray = column2RelArray.filter(function (element) {
            return element !== undefined;
        });
        for (var i = 0; i < column1RelArray.length; i++) {
            column1RelArray[i] = column1RelArray[i].trim();
        }
        for (var i = 0; i < column2RelArray.length; i++) {
            column2RelArray[i] = column2RelArray[i].trim();
        }
        if (this.name == undefined || this.name == "") {
            alert("Please Enter Name.")
            return;
        }
        else if (this.sku == undefined || this.sku == "") {
            alert("Please Enter SKU.")
            return;
        }
        else if (column1RelArray.length == 0 || column1RelArray == null) {
            alert("Please Enter Atleast One Tag")
            return;
        } else if (column2RelArray.length == 0 || column2RelArray == null) {
            alert("Please Enter Atleast One Technology")
            return;
        }
        else if (this.url == undefined || this.url == null) {
            alert("Please Enter Atleast One Url")
            return;
        }
        var file = <File>event.target.files[0];
        let fr = new FileReader();
        fr.onload = (e: any) => {
            var img = new Image;
            img.src = e.target.result;
            img.onload = () => {
                var width = img.naturalWidth;
                var height = img.naturalHeight;

                if (width == 1024 && height == 500) {

                    this.banner_myFiles = <File>event.target.files[0];
                    this.submitbannerimage();
                }
                else {

                    this.banner_myFiles = null;

                }
            };
        };
        fr.readAsDataURL(file)

    }


    detectFilesfeatuerimage(event) {
        var column1RelArray = [];
        var column2RelArray = [];

        $('.select4-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column1RelArray.push($(this).attr('title'));
        });
        $('.select3-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column2RelArray.push($(this).attr('title'));
        });
        column1RelArray = column1RelArray.filter(function (element) {
            return element !== undefined;
        });
        column2RelArray = column2RelArray.filter(function (element) {
            return element !== undefined;
        });
        for (var i = 0; i < column1RelArray.length; i++) {
            column1RelArray[i] = column1RelArray[i].trim();
        }
        for (var i = 0; i < column2RelArray.length; i++) {
            column2RelArray[i] = column2RelArray[i].trim();
        }
        if (this.name == undefined || this.name == "") {
            alert("Please Enter Name.")
            return;
        }
        else if (this.sku == undefined || this.sku == "") {
            alert("Please Enter SKU.")
            return;
        }
        else if (column1RelArray.length == 0 || column1RelArray == null) {
            alert("Please Enter Atleast One Tag")
            return;
        } else if (column2RelArray.length == 0 || column2RelArray == null) {
            alert("Please Enter Atleast One Technology")
            return;
        }
        else if (this.url == undefined || this.url == null) {
            alert("Please Enter Atleast One Url")
            return;
        }
        var file = <File>event.target.files[0];
        let fr = new FileReader();
        fr.onload = (e: any) => {
            var img = new Image;
            img.src = e.target.result;
            img.onload = () => {
                var width = img.naturalWidth;
                var height = img.naturalHeight;
                    if (width == 540 && height == 910) {

                        this.featureimage_myFiles = <File>event.target.files[0];
                        this.submitfeatureimage();
                    }
                    else {
                        this.featureimage_myFiles = null;
                    }
            };
        };
        fr.readAsDataURL(file)
    }

    submitPortfolio() {
        var column1RelArray = [];
        var column2RelArray = [];

        $('.select4-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column1RelArray.push($(this).attr('title'));
        });
        $('.select3-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {

            column2RelArray.push($(this).attr('title'));
        });
        column1RelArray = column1RelArray.filter(function (element) {
            return element !== undefined;
        });
        column2RelArray = column2RelArray.filter(function (element) {
            return element !== undefined;
        });
        for (var i = 0; i < column1RelArray.length; i++) {
            column1RelArray[i] = column1RelArray[i].trim();
        }
        for (var i = 0; i < column2RelArray.length; i++) {
            column2RelArray[i] = column2RelArray[i].trim();
        }
        if (this.name == undefined || this.name == "") {
            alert("Please Enter Name.")
            return;
        }
        else if (this.sku == undefined || this.sku == "") {
            alert("Please Enter SKU.")
            return;
        } 
        else if (column1RelArray.length == 0 || column1RelArray == null) {
            alert("Please Enter Atleast One Tag")
            return;
        } else if (column2RelArray.length == 0 || column2RelArray == null) {
            alert("Please Enter Atleast One Technology")
            return;
        }
        else if (this.url == undefined || this.url == null) {
            alert("Please Enter Atleast One Url")
            return;
        } else if (this.shortdescription == undefined || this.shortdescription == null) {
            alert("Please Enter Short description")
            return;
        }

        else if (this.selectedType == undefined || this.selectedType == null || this.selectedType == '') {
            alert("Please Enter Type")
            return;
        }
        else {

            var descriptionhtml = $('div.note-editable').html();

            var appData = {
                sequenceindex : (this.portfolio.length + 1),
                name: this.name,
                url: this.url,
                shortdescription: this.shortdescription,
                description: descriptionhtml,
                keyword: this.keyword,
                metadescription: this.metadescription,
                tag: column1RelArray.toString(),
                technology: column2RelArray.toString(),
                Android: this.Android,
                youtubelink: this.youtubelink,
                facebooklink: this.facebooklink,
                ios: this.ios,
                huawei: this.huawei,
                store1: this.store1,
                SEOdescription: this.SEOdescription,
                isactive: this.isactive,
                type: this.selectedType,
                theme: this.selectedColor,
                feature1title: this.feature1title,
                feature1desc: this.feature1desc,
                feature2title: this.feature2title,
                feature2desc: this.feature2desc,
                feature3title: this.feature3title,
                feature3desc: this.feature3desc,
                feature4title: this.feature4title,
                feature4desc: this.feature4desc,
                feature5title: this.feature5title,
                feature5desc: this.feature5desc,
                feature6title: this.feature6title,
                feature6desc: this.feature6desc,
                imagetype: this.sliderimagesize,
            };
            this.PortfolioService.iPortfolio(appData, this.sku).then(data => {
               
                if (data.status) {
                    this.isDataLoaded = false;
                    this.PortfolioService.allPortfolio()
                    .then(data => {
                       
                        for (let index = 0; index < data.data.length; index++) {
                            const element = data.data[index];
                            var _idd = element.sequenceindex;
                            if(_idd == undefined || _idd == null || _idd == "")
                            {
                                _idd = 0;
                            }
                            var JDDD = {
                                sequenceindex : _idd,
                                id : element.id,
                                name : element.name,
                                android : element.android,
                                ios : element.ios,
                                huawei : element.huawei,
                                store1 : element.store1,
                                counter : element.counter,
                                isactive : element.isactive,
                                pic : this.image_url +element.logo,
                                tag : element.tag,
                                technology : element.technology,
    
                                url : element.url,
                                shortdescription : element.shortdescription,
                                sku : element.sku,
                                description : element.description,
                                logo : element.logo,
                                banner : element.banner,
                                featureimage : element.featureimage,
                                metakeyword : element.metakeyword,
                                metadescription : element.metadescription,
                                youtubelink : element.youtubelink,
                                facebooklink : element.facebooklink,
                                type : element.type,
                                sliderimage : element.sliderimage,
                                imagetype : element.imagetype,
                                
                                portfoliofeature : {
                                    feature1title : element.portfoliofeature.feature1title,
                                    feature1desc : element.portfoliofeature.feature1desc,
    
                                    feature2title : element.portfoliofeature.feature2title,
                                    feature2desc : element.portfoliofeature.feature2desc,
    
                                    feature3title : element.portfoliofeature.feature3title,
                                    feature3desc : element.portfoliofeature.feature3desc,
    
                                    feature4title : element.portfoliofeature.feature4title,
                                    feature4desc : element.portfoliofeature.feature4desc,
    
                                    feature5title : element.portfoliofeature.feature5title,
                                    feature5desc : element.portfoliofeature.feature5desc,
    
                                    feature6title : element.portfoliofeature.feature6title,
                                    feature6desc : element.portfoliofeature.feature6desc,
                                }
                            }
    
                            this.portfolio.push(JDDD);
                        }
                        this.isDataLoaded = true;
                        this.suggesttag = data.tags;
                    });
                    this.cancelAction();
                    this.ngOnInit();
                    $.notify({
                        message: "successfully inserted"
                    }, {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'right'
                            },
                            delay: 100,
                            timer: 100
                        });
                    $(function () {
                        $('#addPortfolio').modal('toggle');
                    });
                } else {
                    this.message = data.message;
                    alert(this.message)
                }
            });

        }
    }

    submitlogoimage() {
        this.loading = true;
        if (this.name == undefined || this.name == "") {
            this.loading = false;
            alert("Please Enter Name.")
            return;
        }
        else if (this.sku == undefined || this.sku == "") {
            this.loading = false;
            alert("Please Enter SKU.")
            return;
        }
        else if (this.url == undefined || this.url == null) {
            alert("Please Enter Atleast One Url")
            return;
        } else if (this.shortdescription == undefined || this.shortdescription == null) {
            alert("Please Enter Shortdescription")
            return;
        }
        else if (this.selectedType == undefined || this.selectedType == null || this.selectedType == '') {
            alert("Please Enter Type")
            return;
        }
        else {
            if (this.logo_myFiles != undefined) {
                var is_form_data = true
            } else {
                var is_form_data = false
            }
            var JsonObject = {
                name: this.name,
                sequenceindex : (this.portfolio.length + 1),
            }
            this.PortfolioService.ilogoimage(this.logo_myFiles, JsonObject, this.sku, is_form_data).then(data => {
                this.loading = false;
                if (data.status) {
                    $.notify({
                        message: "successfully inserted"
                    }, {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'right'
                            },
                            delay: 100,
                            timer: 100
                        });
                } else {
                    alert(data.message)
                }
            });
        }
    }

    submitsinglesliderimage() {
        if (this.name == undefined || this.name == "") {
            alert("Please Enter Name.")
            return;
        }
        else if (this.sku == undefined || this.sku == "") {
            alert("Please Enter SKU.")
            return;
        }
        else if (this.url == undefined || this.url == null) {
            alert("Please Enter Atleast One Url")
            return;
        } else if (this.shortdescription == undefined || this.shortdescription == null) {
            alert("Please Enter Shortdescription")
            return;
        }

        else if (this.selectedType == undefined || this.selectedType == null || this.selectedType == '') {
            alert("Please Enter Type")
            return;
        }
        else {
            if (this.singlesliderimage_myFiles != undefined) {
                var is_form_data = true
            } else {
                var is_form_data = false
            }
            var JsonObject = {
                name: this.name,
                sequenceindex : (this.portfolio.length + 1),
            }
            this.PortfolioService.isinglesliderimage(this.singlesliderimage_myFiles, JsonObject, this.sku, is_form_data).then(data => {
                if (data.status) {
                    this.sliderimagearray.push(data.imagedata)
                } else {
                    alert(data.message)
                }
            });
        }
    }
    deletesliderimage(image, i) {
        var data = {
            // version:image.version
        }
        this.imageid = image.id;
        this.PortfolioService.dsinglesliderimage(data, this.imageid).then(data => {
            if (data.status) {
                this.sliderimagearray.splice(i, 1);
            }
        })
    }
    submitbannerimage() {
        this.loading = true;
        if (this.name == undefined || this.name == "") {
            this.loading = false;
            alert("Please Enter Name.")
            return;
        }
        else if (this.sku == undefined || this.sku == "") {
            this.loading = false;
            alert("Please Enter SKU.")
            return;
        }
        else if (this.url == undefined || this.url == null) {
            alert("Please Enter Atleast One Url")
            return;
        } else if (this.shortdescription == undefined || this.shortdescription == null) {
            alert("Please Enter Shortdescription")
            return;
        }

        else if (this.selectedType == undefined || this.selectedType == null || this.selectedType == '') {
            alert("Please Enter Type")
            return;
        }
        else {
            if (this.banner_myFiles != undefined) {
                var is_form_data = true
            } else {
                var is_form_data = false
            }
            var JsonObject = {
                name: this.name,
                sequenceindex : (this.portfolio.length + 1),
            }
            this.PortfolioService.ibannerimage(this.banner_myFiles, JsonObject, this.sku, is_form_data).then(data => {
                this.loading = false;
                if (data.status) {
                    $.notify({
                        message: "Successfully inserted"
                    }, {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'right'
                            },
                            delay: 100,
                            timer: 100
                        });
                } else {
                    alert(data.message)
                }
            });
        }
    }
    navigate(url, id) {

        var subtitle1 = url.replace(/\s/g, "-")
        let url2 = this.apiconstant.MainUrl + 'portfoliodetail/' + subtitle1 + '/' + btoa(id)
        window.open(url2.toString(), '_blank')

    }

    submitsliderimage() {
        this.loading = true;
        if (this.name == undefined || this.name == "") {
            this.loading = false;
            alert("Please Enter Name.")
            return;
        }
        else if (this.sku == undefined || this.sku == "") {
            this.loading = false;
            alert("Please Enter SKU.")
            return;
        }
        else if (this.url == undefined || this.url == null) {
            alert("Please Enter Atleast One Url")
            return;
        } else if (this.shortdescription == undefined || this.shortdescription == null) {
            alert("Please Enter Shortdescription")
            return;
        }

        else if (this.selectedType == undefined || this.selectedType == null || this.selectedType == '') {
            alert("Please Enter Type")
            return;
        }
        else {


            if (this.sliderimage_myFiles.length >= 1) {
                if (this.sliderimage_myFiles != undefined) {
                    var is_form_data = true
                } else {
                    var is_form_data = false
                }
                var JsonObject = {
                    name: this.name,
                    imagetype: this.sliderimagesize,
                    sequenceindex : (this.portfolio.length + 1),
                }
                this.PortfolioService.isliderimage(this.sliderimage_myFiles, JsonObject, this.sku, is_form_data).then(data => {

                    this.loading = false;
                    if (data.status) {
                        this.sliderimagearray = this.sliderimagearray.concat(data.imagedata);
                        this.sliderimage_myFiles = [];
                        $("#cleardata").val("");
                        $.notify({
                            message: "successfully inserted"
                        }, {
                                type: 'success',
                                placement: {
                                    from: 'bottom',
                                    align: 'right'
                                },
                                delay: 100,
                                timer: 100
                            });
                    } else {
                        alert(data.message)
                    }
                });
            } else {
                this.loading = false;
                alert("At least 1 images required for slider")
            }
        }
    }


    submitfeatureimage() {
        this.loading = true;
        
        if (this.name == undefined || this.name == "") {
            this.loading = false;
            alert("Please Enter Name.")
            return;
        }
        else if (this.sku == undefined || this.sku == "") {
            this.loading = false;
            alert("Please Enter SKU.")
            return;
        }
        else {
          
            if (this.featureimage_myFiles != undefined) {
                var is_form_data = true
            } else {
                var is_form_data = false
            }
            var JsonObject = {
                name: this.name,
                sequenceindex : (this.portfolio.length + 1),
            }
            this.PortfolioService.ifeatureimage(this.featureimage_myFiles, JsonObject, this.sku, is_form_data).then(data => {
                this.loading = false;
                if (data.status) {
                    $.notify({
                        message: "Successfully inserted"
                    }, {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'right'
                            },
                            delay: 100,
                            timer: 100
                        });
                } else {
                    alert(data.message)
                }
            });
        }
    }

    showPortfolio(portfolio, i) {
        $(function () {
            var drEvent = $('.dropify').dropify();
            drEvent.on('dropify.afterClear', function (event, element) {
            });
        });
        this.sliderimagearray = [];
        $(".radiodisabled").attr('disabled', true);
        $(".opacitydown").css('opacity', '.5');
        this.sliderimagesize1 = "portrait";
        var tagarr = [];
        var counter = 0
        new Promise((resolver011, reject) => {
            for (var j = 0; j < this.suggesttag.length; j++) {
                (async () => {
                    await new Promise((resolver111, reject) => {
                        tagarr.push(this.suggesttag[j].id);
                        resolver111(0)
                    }).then(aadg => {
                        counter++
                        if (counter == this.suggesttag.length) {
                            resolver011(0);
                        }
                    })
                })();
            }
        }).then(aadg => {
            var str = portfolio.tag;
            var arr = str.split(",");
            var tagarray = tagarr.map(String);
            const intersection = arr.filter(element => tagarray.includes(element));
            var inttagarray = intersection.map(Number);
            var selectedtag = [];
            var tempFillList01 = [];
            (async () => {
                await new Promise((resolver01, reject) => {
                    for (var k = 0; k < this.suggesttag.length; k++) {
                        (async () => {
                            await new Promise((resolver11, reject) => {
                                var tempFillList1 = [];
                                for (var z = 0; z < this.suggesttag.length; z++) {
                                    (async () => {
                                        await new Promise((resolver31, reject) => {
                                            if (inttagarray[k] == this.suggesttag[z].id) {
                                                selectedtag[k] = this.suggesttag[z].name;
                                                resolver31(0);
                                            } else {
                                                resolver31(0);
                                            }
                                        }).then(aadg => {
                                            tempFillList1.push(0);
                                            if (tempFillList1.length == this.suggesttag.length) {
                                                resolver11(0);
                                            }
                                        })
                                    })();
                                }
                            }).then(aadg => {
                                tempFillList01.push(0);
                                if (tempFillList01.length == this.suggesttag.length) {
                                    $('#mySelect4').val(null).trigger("change");
                                    resolver01(0);
                                }
                            })
                        })();
                    }
                }).then(aadg => {
                    this.selectedtag = selectedtag;
                    $('#mySelect4').val(this.selectedtag).trigger("change");
                })
            })();
            var str2 = portfolio.technology;
            var arr2 = str2.split(",");
            var tagarray2 = tagarr.map(String);
            const intersection2 = arr2.filter(element => tagarray2.includes(element));
            var inttagarray2 = intersection2.map(Number);
            var selectedtag2 = [];
            var tempFillList0 = [];
            (async () => {
                await new Promise((resolver0, reject) => {
                    for (var y = 0; y < this.suggesttag.length; y++) {
                        (async () => {
                            await new Promise((resolver1, reject) => {
                                var tempFillList = [];
                                for (var w = 0; w < this.suggesttag.length; w++) {
                                    (async () => {
                                        await new Promise((resolver3, reject) => {
                                            if (inttagarray2[y] == this.suggesttag[w].id) {
                                                selectedtag2[y] = this.suggesttag[w].name;
                                                resolver3(0);
                                            } else {
                                                resolver3(0);
                                            }
                                        }).then(aadg => {
                                            tempFillList.push(0);
                                            if (tempFillList.length == this.suggesttag.length) {

                                                resolver1(0);
                                            }
                                        })
                                    })();
                                }
                            }).then(aadg => {
                                tempFillList0.push(0);
                                if (tempFillList0.length == this.suggesttag.length) {
                                    $('#mySelect5').val(null).trigger("change");
                                    resolver0(0);
                                }
                            })
                        })();

                    }
                }).then(aadg => {
                    this.selectedtechnology = selectedtag2;
                    $('#mySelect5').val(this.selectedtechnology).trigger("change");
                })
            })();
        })
        this.i = i;
        this.id = portfolio.id;
        this.name = portfolio.name;
        this.url = portfolio.url;
        this.shortdescription = portfolio.shortdescription;
        this.sku = portfolio.sku;
        this.description = portfolio.description;
        if (portfolio.logo != null && portfolio.logo != undefined && portfolio.logo != "") {

            this.logoshow = true;
            this.logo = portfolio.logo;
        }
        if (portfolio.banner != null && portfolio.banner != undefined && portfolio.banner != "") {
            this.showbanner = true;
            this.banner = portfolio.banner;
        }
        if (portfolio.featureimage != null && portfolio.featureimage != undefined && portfolio.featureimage != "") {
            this.showfeatureimage = true;
            this.featureimage = portfolio.featureimage;
        }

        if (this.description != null) {
            $('div.note-editable').append(this.description);
        }
        this.keyword = portfolio.metakeyword;
        this.metadescription = portfolio.metadescription;
        this.Android = portfolio.android;
        this.youtubelink = portfolio.youtubelink;
        this.facebooklink = portfolio.facebooklink;
        this.ios = portfolio.ios;
        this.huawei = portfolio.huawei;
        this.store1 = portfolio.store1;
        this.selectedType = portfolio.type;
        if (portfolio.portfoliofeature != null && portfolio.portfoliofeature != undefined && portfolio.portfoliofeature != "") {
            this.feature1title = portfolio.portfoliofeature.feature1title;
            this.feature1desc = portfolio.portfoliofeature.feature1desc;
            this.feature2title = portfolio.portfoliofeature.feature2title;
            this.feature2desc = portfolio.portfoliofeature.feature2desc;
            this.feature3title = portfolio.portfoliofeature.feature3title;
            this.feature3desc = portfolio.portfoliofeature.feature3desc;
            this.feature4title = portfolio.portfoliofeature.feature4title;
            this.feature4desc = portfolio.portfoliofeature.feature4desc;
            this.feature5title = portfolio.portfoliofeature.feature5title;
            this.feature5desc = portfolio.portfoliofeature.feature5desc;
            this.feature6title = portfolio.portfoliofeature.feature6title;
            this.feature6desc = portfolio.portfoliofeature.feature6desc;
        }
        this.isactive = portfolio.isactive;
        if (portfolio.sliderimage != null) {
            this.show = true
        } else {
            this.show = false
        }

        if (portfolio.logo == null || portfolio.logo == undefined || portfolio.logo == "") {
            this.showinputlogo = true;
        } else {
            this.showinputlogo = false;
        }

        if (portfolio.banner == null || portfolio.banner == undefined || portfolio.banner == "") {

            this.showinputbanner = true;
        } else {
            this.showinputbanner = false;
        }


        if (portfolio.featureimage == null || portfolio.featureimage == undefined || portfolio.featureimage == "") {

            this.showinputfeatureimage = true;
        } else {

            this.showinputfeatureimage = false;
        }
        var data = {
            sku: portfolio.sku
        }

        this.PortfolioService.allimage(data).then(data => {

            if (data.status) {
                this.sliderimagearray = data.data;
                if (this.sliderimagearray.length > 0) {
                    $(function () {
                        var drEvent = $('.dropify').dropify();
                        drEvent.on('dropify.afterClear', function (event, element) {
                        });
                    });
                    if (this.sliderimagearray.length > 0) {
                        this.sliderstring = this.apiconstant.ServerUrl + "uploads/portfolio/" + this.sliderimagearray[0]["name"];
                    }
                    var tmpImg = new Image();
                    tmpImg.src = this.sliderstring;
                    $(() => {
                        $(tmpImg).on('load', data => {
                            var orgWidth = tmpImg.width;
                            var orgHeight = tmpImg.height;
                            if (orgWidth > 1300) {
                                this.sliderimagesize = "landscape";
                                this.sliderimagesize1 = "landscape";
                            }
                            else {
                                this.sliderimagesize = "portrait";
                                this.sliderimagesize1 = "portrait";
                            }
                        });
                    });
                } else {

                    if (portfolio.imagetype != "" && portfolio.imagetype != undefined && portfolio.imagetype != null) {

                        this.sliderimagesize = portfolio.imagetype.toString()
                        this.sliderimagesize1 = portfolio.imagetype.toString()

                    } else {
                        this.sliderimagesize = "portrait";
                        this.sliderimagesize1 = "portrait";
                    }
                }

            }
        })
    }

    deleteconfirmation(id, i) {
        this.i = i;
        this.id = id;
    }

    timeForamte()
    {
        var timezone_offset_min = new Date().getTimezoneOffset();
      var  offset_hrs = parseInt(Math.abs(timezone_offset_min/60).toString());
      var  offset_min = Math.abs(timezone_offset_min%60),
        timezone_standard;

    var offset_hrs_S = "";
    var offset_min_S = "";

    if(offset_hrs < 10)
    {
        offset_hrs_S = '0' + offset_hrs;
    }
    else
    {
        offset_hrs_S =  offset_hrs.toString();
    }
    
    if(offset_min < 10)
    {
        offset_min_S = '0' + offset_min;
    }
    else
    {
        offset_min_S = offset_min.toString();
    }
    
    // Add an opposite sign to the offset
    // If offset is 0, it means timezone is UTC
    if(timezone_offset_min < 0)
        timezone_standard = '+' + offset_hrs_S + ':' + offset_min_S;
    else if(timezone_offset_min > 0)
        timezone_standard = '-' + offset_hrs_S + ':' + offset_min_S;
    else if(timezone_offset_min == 0)
        timezone_standard = 'Z';
    
    // Timezone difference in hours and minutes
    // String such as +5:30 or -6:00 or Z
   
    return timezone_standard;
    }

    dateFormate()
    {
        var dt = new Date();
      var  current_date = dt.getDate();
      var current_month = dt.getMonth() + 1;
      var current_year = dt.getFullYear();
      var  current_hrs = dt.getHours();
      var current_mins = dt.getMinutes();
      var  current_secs = dt.getSeconds();
      var  current_datetime;
    
    // Add 0 before date, month, hrs, mins or secs if they are less than 0
  var  current_date_S = current_date < 10 ? '0' + current_date : current_date;
  var current_month_S = current_month < 10 ? '0' + current_month : current_month;
  var current_hrs_S = current_hrs < 10 ? '0' + current_hrs : current_hrs;
   var current_mins_S = current_mins < 10 ? '0' + current_mins : current_mins;
   var current_secs_S = current_secs < 10 ? '0' + current_secs : current_secs;
    
    // Current datetime
    // String such as 2016-07-16T19:20:30
    current_datetime = current_year + '-' + current_month_S + '-' + current_date_S + 'T' + current_hrs_S + ':' + current_mins_S + ':' + current_secs_S;

    return current_datetime;
    }


    generatexmlCode(portfoliodata, i) {
      
    this.viewcodexmldescription = "";
    var data = {
        sku: portfoliodata.sku
    }
    this.PortfolioService.allimage(data).then(data1 => {

        var appgameName = portfoliodata.name;

        var subtitle1 = portfoliodata.url.replace(/\s/g, "-")
       
        var appgameUrl = this.apiconstant.MainUrl+"portfoliodetail/"+subtitle1+"/"+btoa(portfoliodata.id);
        var logoImagePath = portfoliodata.logo;
        var bannerImagePath = portfoliodata.banner;
        var featureimageImagePath = portfoliodata.featureimage;
    
    
        var createdDate = this.dateFormate() + this.timeForamte();
    
        var root = builder.create('url');  
    
        root.ele('loc',appgameUrl)
        root.ele('lastmod',createdDate)
        var imgLogo =  root.ele('image:image')
        imgLogo.ele('image:loc','https://api.phoenixgames.in/uploads/portfolio/'+logoImagePath)
        imgLogo.ele('image:title','<![CDATA['+appgameName+' Logo Phoenix Games]]>')
        imgLogo.ele('image:caption','<![CDATA['+appgameName+' Logo Phoenix Games]]>')
    
        var imgBanner =  root.ele('image:image')
        imgBanner.ele('image:loc','https://api.phoenixgames.in/uploads/portfolio/'+bannerImagePath)
        imgBanner.ele('image:title','<![CDATA['+appgameName+' Banner Phoenix Games]]>')
        imgBanner.ele('image:caption','<![CDATA['+appgameName+' Banner Phoenix Games]]>')
    
        var imgFeatureimage =  root.ele('image:image')
        imgFeatureimage.ele('image:loc','https://api.phoenixgames.in/uploads/portfolio/'+featureimageImagePath)
        imgFeatureimage.ele('image:title','<![CDATA['+appgameName+' Feature Phoenix Games]]>')
        imgFeatureimage.ele('image:caption','<![CDATA['+appgameName+' Feature Phoenix Games]]>')
    
        if (data1.status) 
        {
            for (let index = 0; index < data1.data.length; index++) 
            {   
                var screenshotImagePath = data1.data[index]["name"];
               
                var imgScreenshot =  root.ele('image:image')
                imgScreenshot.ele('image:loc','https://api.phoenixgames.in/uploads/portfolio/'+screenshotImagePath)
                imgScreenshot.ele('image:title','<![CDATA['+appgameName+' Screenshot '+(index +1)+' Phoenix Games]]>')
                imgScreenshot.ele('image:caption','<![CDATA['+appgameName+' Screenshot '+(index +1)+' Phoenix Games]]>')
            }
        }

        var xml = root.end({ pretty: true});
    
        var finalstring = xml.toString();
     
        let re = /\&lt;/gi;
        let re1 = /\&gt;/gi;
        let re2 = /\=/gi;
        var finalstring1 = finalstring.replace(re,'<')
        var finalstring2 = finalstring1.replace(re1,'>')
        var finalstring3 = finalstring2.replace(re2,'%3D')
        this.viewcodexmldescription = finalstring3;
    })
   
   
    }

    updatePortfolio() {
        var column1RelArray = [];
        var column2RelArray = [];

        $('.select4-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {
            column1RelArray.push($(this).attr('title'));
        });
        $('.select3-tags').siblings('span.select2-container--default').children('span.selection').children('span.select2-selection').children('ul.select2-selection__rendered').children('li').each(function () {
            column2RelArray.push($(this).attr('title'));
        });
        column1RelArray = column1RelArray.filter(function (element) {
            return element !== undefined;
        });
        column2RelArray = column2RelArray.filter(function (element) {
            return element !== undefined;
        });
        for (var i = 0; i < column1RelArray.length; i++) {
            column1RelArray[i] = column1RelArray[i].trim();
        }
        for (var i = 0; i < column2RelArray.length; i++) {
            column2RelArray[i] = column2RelArray[i].trim();
        }
        if (this.name == undefined || this.name == "") {
            alert("Please Enter Name")
            return;
        }
        else if (this.sku == undefined || this.sku == "") {
            alert("Please Enter SKU")
            return;
        } else if (column1RelArray == [] || column1RelArray == null) {
            alert("Please Enter Atleast One Tag")
            return;
        } else if (column2RelArray == [] || column2RelArray == null) {
            alert("Please Enter Atleast One Tag")
            return;
        }
        else if (this.shortdescription == undefined || this.shortdescription == null) {
            alert("Please Enter Short description")
            return;
        }
        else {
            var descriptionhtml = $('.summernote2').siblings('.note-editor').children('.note-editing-area').children('div.note-editable').html();
            var appData = {
                sequenceindex : (this.portfolio.length + 1),
                name: this.name,
                description: descriptionhtml,
                keyword: this.keyword,
                shortdescription: this.shortdescription,
                metadescription: this.metadescription,
                tag: column1RelArray.toString(),
                technology: column2RelArray.toString(),
                Android: this.Android,
                youtubelink: this.youtubelink,
                facebooklink: this.facebooklink,
                ios: this.ios,
                huawei: this.huawei,
                store1: this.store1,
                SEOdescription: this.SEOdescription,
                isactive: this.isactive,
                type: this.selectedType,
                theme: this.selectedColor,
                feature1title: this.feature1title,
                feature1desc: this.feature1desc,
                feature2title: this.feature2title,
                feature2desc: this.feature2desc,
                feature3title: this.feature3title,
                feature3desc: this.feature3desc,
                feature4title: this.feature4title,
                feature4desc: this.feature4desc,
                feature5title: this.feature5title,
                feature5desc: this.feature5desc,
                feature6title: this.feature6title,
                feature6desc: this.feature6desc,
                imagetype: this.sliderimagesize
            };

            this.PortfolioService.uPortfolio(this.id, appData).then(data => {
                if (data.status) {
                    this.isDataLoaded = false;
                    this.PortfolioService.allPortfolio()
                    .then(data => {
                        for (let index = 0; index < data.data.length; index++) {
                            const element = data.data[index];
                            var _idd = element.sequenceindex;
                            if(_idd == undefined || _idd == null || _idd == "")
                            {
                                _idd = 0;
                            }
                            var JDDD = {
                                sequenceindex : _idd,
                                id : element.id,
                                name : element.name,
                                android : element.android,
                                ios : element.ios,
                                huawei : element.huawei,
                                store1 : element.store1,
                                counter : element.counter,
                                isactive : element.isactive,
                                pic : this.image_url +element.logo,
                                tag : element.tag,
                                technology : element.technology,
    
                                url : element.url,
                                shortdescription : element.shortdescription,
                                sku : element.sku,
                                description : element.description,
                                logo : element.logo,
                                banner : element.banner,
                                featureimage : element.featureimage,
                                metakeyword : element.metakeyword,
                                metadescription : element.metadescription,
                                youtubelink : element.youtubelink,
                                facebooklink : element.facebooklink,
                                type : element.type,
                                sliderimage : element.sliderimage,
                                imagetype : element.imagetype,
                                
                                portfoliofeature : {
                                    feature1title : element.portfoliofeature.feature1title,
                                    feature1desc : element.portfoliofeature.feature1desc,
    
                                    feature2title : element.portfoliofeature.feature2title,
                                    feature2desc : element.portfoliofeature.feature2desc,
    
                                    feature3title : element.portfoliofeature.feature3title,
                                    feature3desc : element.portfoliofeature.feature3desc,
    
                                    feature4title : element.portfoliofeature.feature4title,
                                    feature4desc : element.portfoliofeature.feature4desc,
    
                                    feature5title : element.portfoliofeature.feature5title,
                                    feature5desc : element.portfoliofeature.feature5desc,
    
                                    feature6title : element.portfoliofeature.feature6title,
                                    feature6desc : element.portfoliofeature.feature6desc,
                                }
                            }
    
                            this.portfolio.push(JDDD);
                        }
                        this.isDataLoaded = true;
                        this.suggesttag = data.tags;
                    });
                    this.cancelAction();
                    $(function () {
                        $('#updatePortfolio').modal('toggle');
                    });
                    $.notify({
                        message: "Successfully updated"
                    }, {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'right'
                            },
                            delay: 100,
                            timer: 100
                        });
                    location.reload();
                    this.cancelAction();
                } else {
                    this.message = data.message;
                    $.notify({
                        message: this.message
                    }, {
                            type: 'danger',
                            placement: {
                                from: 'bottom',
                                align: 'right'
                            },
                            delay: 100,
                            timer: 100
                        });
                }
            });
           
        }
    }

    deletePortfolio() {

        this.PortfolioService.dPortfolio(this.id).then(data => {

            if (data.status) {
                this.portfolio.splice(this.i, 1);
                $.notify({
                    message: "Successfully deleted"
                }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
            } else {
                this.cancelAction();
            }
        });
    }

    activate(i, portfoliodata) {

        this.j = i;
        this.pid = portfoliodata.id;
        var _isactive = portfoliodata.isactive;
        this.PortfolioService.isactive(this.pid).then(data => {
            if(data.status)
            {
                this.portfolio[i].isactive = !_isactive;
            }
            // this.isDataLoaded = false;
        //    this.PortfolioService.allPortfolio()
        //    .then(data => {
        //        for (let index = 0; index < data.data.length; index++) {
        //            const element = data.data[index];
        //            var _idd = element.sequenceindex;
        //            if(_idd == undefined || _idd == null || _idd == "")
        //            {
        //                _idd = 0;
        //            }
        //            var JDDD = {
        //                sequenceindex : _idd,
        //                id : element.id,
        //                name : element.name,
        //                android : element.android,
        //                ios : element.ios,
        //                counter : element.counter,
        //                isactive : element.isactive,
        //                pic : this.image_url +element.logo,
        //                tag : element.tag,
        //                technology : element.technology,

        //                url : element.url,
        //                shortdescription : element.shortdescription,
        //                sku : element.sku,
        //                description : element.description,
        //                logo : element.logo,
        //                banner : element.banner,
        //                featureimage : element.featureimage,
        //                metakeyword : element.metakeyword,
        //                metadescription : element.metadescription,
        //                youtubelink : element.youtubelink,
        //                facebooklink : element.facebooklink,
        //                type : element.type,
        //                sliderimage : element.sliderimage,
        //                imagetype : element.imagetype,
                       
        //                portfoliofeature : {
        //                    feature1title : element.portfoliofeature.feature1title,
        //                    feature1desc : element.portfoliofeature.feature1desc,

        //                    feature2title : element.portfoliofeature.feature2title,
        //                    feature2desc : element.portfoliofeature.feature2desc,

        //                    feature3title : element.portfoliofeature.feature3title,
        //                    feature3desc : element.portfoliofeature.feature3desc,

        //                    feature4title : element.portfoliofeature.feature4title,
        //                    feature4desc : element.portfoliofeature.feature4desc,

        //                    feature5title : element.portfoliofeature.feature5title,
        //                    feature5desc : element.portfoliofeature.feature5desc,

        //                    feature6title : element.portfoliofeature.feature6title,
        //                    feature6desc : element.portfoliofeature.feature6desc,
        //                }
        //            }

        //            this.portfolio.push(JDDD);
        //        }
        //        this.isDataLoaded = true;
        //        this.suggesttag = data.tags;
        //    });
        })

    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/portfolio/portfolio.page.ts